import { AxiosError } from 'axios';

const getAxiosResponseErrorCode = (responseError: AxiosError) => {
  const err = responseError as any;
  return err?.response?.data?.error?.code ?? err?.code;
};

export default getAxiosResponseErrorCode;
